import { AppSettings } from "@/AppSettings";
import { ConfigurationType } from "@/hooks/form/configuration";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Box, Button, Chip, IconButton, Tooltip } from "@mui/material";
import { FC, useMemo } from "react";

interface IConfigurationSourceDataFormLinkChipProps {
    type: ConfigurationType;
    linked: boolean;
}

const ConfigurationSourceDataFormLinkChip: FC<IConfigurationSourceDataFormLinkChipProps> = ({
    type,
    linked
}) => {

    const typeText = useMemo(() => {
        if (!linked) {
            return 'Unlinked'
        }

        switch (type) {
            case ConfigurationType.Event:
                return "Linked - Event Configuration";
            case ConfigurationType.Form:
                return "Linked - Form Configuration";
            case ConfigurationType.TrialEvent:
                return "Linked - Trial Event Configuration";
            case ConfigurationType.Trial:
            default:
                return "Linked - Trial Form Configuration";
        }
    }, [type, linked]);

    return (
        <Tooltip title={typeText}>
            <Box>
                <FontAwesomeIcon icon={linked ? AppSettings.icons.link : AppSettings.icons.unlink} />
            </Box>
        </Tooltip>
    )
}

export default ConfigurationSourceDataFormLinkChip;